import { render, staticRenderFns } from "./addSign.vue?vue&type=template&id=3a2a274e&scoped=true&"
import script from "./addSign.vue?vue&type=script&lang=js&"
export * from "./addSign.vue?vue&type=script&lang=js&"
import style0 from "./addSign.vue?vue&type=style&index=0&id=3a2a274e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2a274e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a2a274e')) {
      api.createRecord('3a2a274e', component.options)
    } else {
      api.reload('3a2a274e', component.options)
    }
    module.hot.accept("./addSign.vue?vue&type=template&id=3a2a274e&scoped=true&", function () {
      api.rerender('3a2a274e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/components/addSign.vue"
export default component.exports